import React from "react";
import ReplayIcon from "@mui/icons-material/Replay";

import Boards from "../Filters/Boards";
import Epics from "../Filters/Epics";
import clearFilterIcon from "../../../../styles/svg/clearFilterIcon.svg";
import { CustomButton } from "../../../../components/Button/Button";
import { useMyTaskFilterState } from "../../hooks/useMyTaskFilterState";

function Filter({ setFilterDrawer }) {
  const {
    isMobile,
    reporter,
    reporterValue,
    checkedList,
    oldBoard,
    clearFilters,
    changeReporterSearch,
    handleApplyFilter,
  } = useMyTaskFilterState({ onApply: setFilterDrawer });
  return (
    <div className="d-flex align-items-center">
      {isMobile ? (
        <div className="width-100 height-100">
          <div className="filter-head-container">
            <p className="filter-head-mobile">Filter By</p>
            {(oldBoard || reporter) && (
              <div className="d-flex align-items-center" onClick={clearFilters}>
                <ReplayIcon className="reset-mobile-icon" />
                <p className="reset-text-mobile">Reset</p>
              </div>
            )}
          </div>
          <div className="filter-body-container">
            <CustomButton
              className="capitalize mt-2 include-created-by-me-btn"
              sx={{
                width: "100%",
              }}
              variant="outlined"
            >
              <label className="custom-checkbox">
                <input
                  type="checkbox"
                  checked={reporterValue}
                  onClick={changeReporterSearch}
                />
                <span className="checkmark"></span>
                Include created by me
              </label>
            </CustomButton>

            <Boards isAssignToMe={true} />
            {checkedList && checkedList.length === 1 && (
              <Epics isAssignToMe={true} />
            )}
            <div className="mt-4"></div>
            <CustomButton
              className=" capitalize mobile-board-filter-apply-btn"
              variant="outlined"
              onClick={handleApplyFilter}
            >
              Apply
            </CustomButton>
          </div>
        </div>
      ) : (
        <>
          <div className="d-flex align-items-center">
            {oldBoard && (
              <img
                src={clearFilterIcon}
                className="cursor-pointer"
                onClick={clearFilters}
                alt="clear filter"
              />
            )}
          </div>
          {checkedList && checkedList.length === 1 && (
            <Epics isAssignToMe={true} />
          )}
          <div className="mr-4">
            <Boards isAssignToMe={true} />
          </div>
          <CustomButton
            className="white-button capitalize board-filter-button"
            variant="outlined"
          >
            <label className="custom-checkbox">
              <input
                type="checkbox"
                checked={reporterValue}
                onClick={changeReporterSearch}
              />
              <span className="checkmark"></span>
              Include created by me
            </label>
          </CustomButton>
        </>
      )}
    </div>
  );
}

export default Filter;
